"use client"

import { useAppContext } from "@/lib/context/app-context"
import { useParams, useRouter } from "next/navigation"
import { useEffect } from "react"

export default function CheckoutAuthGuard({
  children,
}: {
  children: React.ReactNode
}) {
  const appContext = useAppContext()
  const router = useRouter()
  const params = useParams()

  useEffect(() => {
    if (!appContext.user) {
      router.replace(`/${params.locale}/user?from=${window.location.pathname}`)
    }
  }, [])

  if (!appContext.user) return <></>
  return <>{children}</>
}
